import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import { Tooltip } from '@mui/material';

import ErrorIcon from '@mui/icons-material/ErrorOutline';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import TrueIcon from '@mui/icons-material/Done';

export const ApprovalDeliveredField = ({ source, record = {}, elStyle }) => {
    if (get(record, source) == null) {
        return <Tooltip id="tooltip-top-start" title="In progress" placement="top"> 
                    <TimelapseIcon style={elStyle} />
               </Tooltip>;
    }

    if (get(record, source) === true) {
        return <Tooltip id="tooltip-top-start" title="Sent" placement="top"> 
                    <TrueIcon style={elStyle} />
                </Tooltip>;
    }

    if (get(record, source) === false) {
        return <Tooltip id="tooltip-top-start" title="Failed" placement="top">
                 <ErrorIcon style={elStyle} />
                </Tooltip>;
    }

    return <span style={elStyle} />;
};


ApprovalDeliveredField.propTypes = {
    addLabel: PropTypes.bool,
    elStyle: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

ApprovalDeliveredField.defaultProps = {
    addLabel: true,
    elStyle: {
        display: 'block',
        margin: 'auto',
    },
};

export default ApprovalDeliveredField;
